<template>
  <main class="marketing-email-create-content">
    <marketing-email-form-content v-if="isEmailCreated"
                                  v-model="content"
                                  :email="item"
                                  :type="editorType"
                                  @config="openConfig"
                                  @submit="saveContent(false)" />

    <marketing-email-config-modal :showing.sync="showConfigModal"
                                  :closeable="isEmailCreated"
                                  :item="item"
                                  :is-automation-flow="data.isAutomationFlow"
                                  :content="content"
                                  :has-back-button="!isEmailCreated"
                                  @back="goBackToModelPage"
                                  @saved="onConfigSaved" />

    <div v-if="isEmailCreated && isRawTextEditor"
         class="marketing-email-create-content-actions">
      <button class="btn btn-outline btn-extra-round"
              type="button"
              @click="openTestModal">
          {{$t('message.marketingGenerics.message.testSubmission')}}
      </button>

      <button class="btn btn-primary btn-extra-round"
              @click="onNextStep">
          {{$t('message.generics.message.advance')}}
      </button>
    </div>

    <marketing-email-test v-model="showingTestModal"
                          :item="item" />
  </main>
</template>

<script>
import MarketingEmailTest from "@components/modules/marketing/email/test/MarketingEmailTest";
import MarketingEmailFormContent from "@components/modules/marketing/email/form/content/MarketingEmailFormContent";
import MarketingEmailConfigModal from "@components/modules/marketing/email/config/modal/MarketingEmailConfigModal";
import EventBus from "@packages/event-bus/index";

export default {
  name: "MarketingEmailCreateContent",
  components: {
    MarketingEmailFormContent,
    MarketingEmailConfigModal,
    MarketingEmailTest,
  },

  props: {},

  computed: {
    isAutomationFlow() {
      return this.$store.state.marketing.email.create.data.isAutomationFlow;
    },
    data() {
      return this.$store.state.marketing.email.create.data.title ? this.$store.state.marketing.email.create.data : this.dataInSessionStorage;
    },
    dataInSessionStorage() {
      return JSON.parse(sessionStorage.getItem("email_data"));     
    },
    itemInSessionStorage() {
      return JSON.parse(sessionStorage.getItem("email_item"));     
    },
    item() {
      return this.$store.state.marketing.email.create.item ? this.$store.state.marketing.email.create.item : this.itemInSessionStorage;
    },
    isRawTextEditor() {
      return this.$store.state.marketing.email.create.data.model.editorType ?
       this.$store.state.marketing.email.create.data.model.editorType === "RAW_TEXT" :
       this.dataInSessionStorage.model.editorType === "RAW_TEXT"      
    },
  },

  watch: {},

  data() {
    return {
      content: {
        htmlContent: undefined,
        cssStyle: undefined,
      },
      showConfigModal: false,
      isEmailCreated: false,
      editorType: undefined,
      showingTestModal: false,
    };
  },

  methods: {
    goBackToModelPage() {
      this.$router.push({
        path: "/marketing/email/criar/modelo",
      });
    },
    openTestModal() {
      this.showingTestModal = true;
    },
    async advanceStep() {
      this.$store.commit("SET_EMAIL_CREATE_STEP", 3);
      sessionStorage.setItem("email_step", 3);

      if (this.isAutomationFlow) {
        this.$router.push({
          path: "/marketing/email/criar/verificacao",
        });
      } else {
        this.$router.push({
          path: "/marketing/email/criar/destinatarios",
        });
      }
    },
    openConfig() {
      this.showConfigModal = true;
    },
    onConfigSaved(createdEmail) {
      this.$store.commit("EMAIL_CREATE_SET_ITEM", createdEmail);

      this.isEmailCreated = true;

      this.closeConfigModal();
    },
    closeConfigModal() {
      this.showConfigModal = false;
    },
    openConfigModal() {
      this.showConfigModal = true;
    },
    async saveContent(validateSender = false) {
      this.$store.commit("SET_EMAIL_CONTENT_SAVING", true);

      const updatedEmail = await this.$api.marketing.email.message.edit({
        emailId: this.item.id,
        validateSender,
        data: {
          ...this.item,
          rawContent: this.content.htmlContent,
          cssStyle: this.content.cssStyle,
          editorType: this.editorType,
        },
      });

      this.$store.commit("EMAIL_CREATE_SET_ITEM", updatedEmail);

      this.$store.commit("SET_EMAIL_CONTENT_SAVING", false);
    },
    async onNextStep() {
      await this.saveContent(true);
      this.advanceStep();
    },
  },

  mounted() {
    if (!this.item) {
      this.openConfigModal();

      this.content = {
        htmlContent: this.data.model.htmlContent,
        cssStyle: this.data.model.cssStyle,
        compiledEmail: undefined,
      };
    } else {
      this.content = {
        htmlContent: this.item.rawContent,
        cssStyle: this.item.cssStyle,
        compiledEmail: this.item.content,
      };

      this.isEmailCreated = true;
    }

    this.editorType = this.data.model.editorType;

    EventBus.$on("EMAIL_CREATE_NEXT_STEP", this.onNextStep);
  },

  beforeDestroy() {
    EventBus.$off("EMAIL_CREATE_NEXT_STEP", this.onNextStep);
  },
};
</script>

<style lang="scss" scoped>
.marketing-email-create-content {
  .marketing-email-create-content-actions {
    display: flex;
    justify-content: center;
    gap: 30px;
  }
}
</style>

